import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchBrands, createBrand, updateBrand, deleteBrand } from "./thunks";
import { Brand } from "@/types";
import { toast } from "react-toastify";

interface PaginatedBrands {
  data: Brand[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface BrandsState {
  brands: PaginatedBrands;
  loading: boolean;
  error: string | null;
}

const initialState: BrandsState = {
  brands: { data: [] },
  loading: false,
  error: null,
};

const BrandSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    clearSuppliers: (state) => {
      state.brands = { data: [] };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchBrands.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrands.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const payload = action.payload;

        if (Array.isArray(payload.data)) {
          // Dados não paginados
          state.brands = { data: payload.data };
        } else {
          // Dados paginados
          state.brands = {
            data: payload.data.data,
            total: payload.data.total,
            currentPage: payload.data.current_page,
            perPage: payload.data.per_page,
          };
        }
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })
      // Create
      .addCase(createBrand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBrand.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.brands.data.push(action.payload.data);
        toast.success("Marca cadastrada com sucesso!");
      })
      .addCase(createBrand.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Não foi possível cadastrar essa marca, tente novamente!");
      })

      // Update
      .addCase(updateBrand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBrand.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const index = state.brands.data.findIndex(
          (s) => s.id == action.payload.data.id,
        );
        if (index !== -1) {
          state.brands.data[index] = action.payload.data;
        }
        toast.success("Marca atualizado com sucesso!");
      })
      .addCase(updateBrand.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      })

      // Delete
      .addCase(deleteBrand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBrand.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.brands.data = state.brands.data.filter(
          (s) => String(s.id) != action.payload.data.id,
        );
        toast.success("Marca excluída com sucesso!");
      })
      .addCase(deleteBrand.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      });
  },
});

export default BrandSlice.reducer;
